import { Link } from "react-router-dom";
import { FileCheck2, Receipt } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatInt, formatMoney, lazyPage } from "@vixio/ui";
import { InvoicesPage, useFiscalKpis } from "./InvoicesPage";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const FiscalSettingsPage = lazyPage(() => import("./FiscalSettingsPage"), "FiscalSettingsPage");

function FiscalWidget() {
  const org = useOrg();
  const k = useFiscalKpis(org.id).data;
  return (
    <dl className="vx-dl">
      <dt>Emitido no mês</dt>
      <dd className="num">{formatMoney(k?.issuedMonthCents ?? 0)}</dd>
      <dt>Na fila</dt>
      <dd className="num">{formatInt(k?.queue ?? 0)}</dd>
      <dt>Rejeitadas</dt>
      <dd className={(k?.rejected ?? 0) > 0 ? "num text-crit" : "num"}>{formatInt(k?.rejected ?? 0)}</dd>
      <dt />
      <dd>
        <Link to="/dinheiro/notas">Abrir notas</Link>
      </dd>
    </dl>
  );
}

export default defineModuleUi({
  key: "fiscal",
  title: "NFS-e",
  domain: "money",
  icon: Receipt,
  menu: [
    { path: "/dinheiro/notas", label: "Notas fiscais", minRole: "member", icon: Receipt, order: 60, keywords: "nfs-e iss retenção prefeitura" },
    { path: "/configuracoes/fiscal", label: "Fiscal (NFS-e)", minRole: "member", icon: FileCheck2, domain: "platform", order: 25, keywords: "provedor alíquota lc 116 certificado" },
  ],
  routes: [
    { path: "/dinheiro/notas", element: <InvoicesPage />, minRole: "member" },
    { path: "/configuracoes/fiscal", element: <FiscalSettingsPage />, minRole: "member" },
  ],
  widgets: [{ key: "fiscal.summary", title: "Notas fiscais", minRole: "member", span: 1, order: 40, element: FiscalWidget }],
});
